import type { State } from 'src/replicant/State';
import { rewards, TutorialStep } from './tutorial.ruleset';

export function isTutorialStepComplete(
  state: State,
  step: TutorialStep,
): boolean {
  const { tutorial } = state;

  switch (step) {
    case 'basicGameplay':
    case 'careForPets':
    case 'chatWithPets':
    case 'friendReferral':
    case 'profile':
    case 'match3':
    case 'visitFriend':
      return tutorial[`${step}Shown`];

    case 'puzzleCoinsBasic':
      return tutorial.basicGameplayShown;

    case 'puzzleCoinsCare':
      return tutorial.careForPetsShown;

    default:
      return tutorial[step];
  }
}

export function getTutorialReward(state: State, step: TutorialStep): number {
  if (isNoRewardOverridden(state, step)) return 0;
  return rewards[step];
}

// Skip rewards for certain tutorial steps
function isNoRewardOverridden(state: State, step: TutorialStep) {
  return (
    step === 'friendReferral' ||
    step === 'profile' ||
    step === 'visitFriend' ||
    step === 'catalog'
  );
}
